export default "__VITE_ASSET__gwtjb4Jr__"